import { render, staticRenderFns } from "./FlightItemApp.vue?vue&type=template&id=c8aed646&scoped=true"
import script from "./FlightItemApp.vue?vue&type=script&lang=js"
export * from "./FlightItemApp.vue?vue&type=script&lang=js"
import style0 from "./FlightItemApp.vue?vue&type=style&index=0&id=c8aed646&prod&scoped=true&lang=css"
import style1 from "./FlightItemApp.vue?vue&type=style&index=1&id=c8aed646&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8aed646",
  null
  
)

export default component.exports